import mod from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./section-group.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./section-group.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/business/select-member/section/section-group.vue?vue&type=script&lang=js&
// module id = 84
// module chunks = 0